import { Link, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { IconEye } from "@tabler/icons-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { api } from "@/lib/convex-api";

export const Route = createFileRoute("/_authenticated/customers/")({
	component: CustomersPage,
});

function CustomersPage() {
	const data = useQuery(api.admin.listUsers, {
		role: "customer",
		limit: 50,
	});
	const isLoading = data === undefined;

	return (
		<div className="container mx-auto px-4 py-10 lg:px-6">
			<div className="mb-8">
				<h1 className="font-bold text-3xl">Customer Management</h1>
				<p className="mt-1 text-muted-foreground text-sm">
					View and manage customer accounts.
				</p>
			</div>

			{isLoading ? (
				<div className="space-y-3">
					{Array.from({ length: 8 }).map((_, i) => (
						<Skeleton className="h-12 w-full" key={`skeleton-${String(i)}`} />
					))}
				</div>
			) : !data || data.users.length === 0 ? (
				<div className="flex items-center justify-center rounded-md border py-10">
					<p className="text-muted-foreground">No customers found.</p>
				</div>
			) : (
				<div className="rounded-md border">
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>Name</TableHead>
								<TableHead>Email</TableHead>
								<TableHead>Roles</TableHead>
								<TableHead>Joined</TableHead>
								<TableHead>Actions</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{data.users.map((user: (typeof data.users)[number]) => (
								<TableRow key={user._id}>
									<TableCell className="font-medium">{user.name}</TableCell>
									<TableCell>{user.email}</TableCell>
									<TableCell>
										<div className="flex gap-1">
											{user.roles.map((role: string) => (
												<Badge key={role} variant="secondary">
													{role}
												</Badge>
											))}
										</div>
									</TableCell>
									<TableCell>
										{new Date(user.createdAt).toLocaleDateString()}
									</TableCell>
									<TableCell>
										<Button asChild size="sm" variant="outline">
											<Link
												to="/customers/$userId"
												params={{ userId: user._id }}
											>
												<IconEye className="mr-2 h-4 w-4" />
												View
											</Link>
										</Button>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
			)}
		</div>
	);
}
